import React from 'react';
import styles from "./NoResults.module.sass";
import { useGlobalValue } from "../../state/GlobalProvider";
import { SovosBox } from "mosaic-react";
import { Search } from "mosaic-react-icons";
const stylesJs = {
  noresultsIcon: {
    width: '78px',
    height: '78px',
    flexShrink: 0,
    position: 'absolute',
    top: '42%',
    left: '46%'
  }
};
const NoResults = () => {
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-container"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-icons"]
  }, /*#__PURE__*/React.createElement(SovosBox, {
    sx: stylesJs.noresultsIcon
  }, /*#__PURE__*/React.createElement(Search, {
    sx: {
      fontSize: 78,
      color: '#072448'
    }
  })), /*#__PURE__*/React.createElement("svg", {
    className: styles["noresults-icon-background"],
    xmlns: "http://www.w3.org/2000/svg",
    width: "77",
    height: "65",
    viewBox: "0 0 77 65",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 44.5C77.0001 61.9552 67.5411 65 41.1429 65C14.7446 65 0 50.8497 0 33.3945C0 15.9393 3.24878 0 29.6471 0C56.0453 0 77.0001 27.0448 77.0001 44.5Z",
    fill: "#015FFF",
    "fill-opacity": "0.3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles["noresults-text"]
  }, /*#__PURE__*/React.createElement("h5", null, i18n`no_results`), /*#__PURE__*/React.createElement("p", null, i18n`no_results_description`)));
};
export default NoResults;